// extracted by mini-css-extract-plugin
export default {"header":"ProjectItemDetails_header__hGAba","content":"ProjectItemDetails_content__ee9JI","github_link":"ProjectItemDetails_github_link__A4Y00"};